import { render, staticRenderFns } from "./ColorSelection.vue?vue&type=template&id=2d596ec6&scoped=true&"
import script from "./ColorSelection.vue?vue&type=script&lang=ts&"
export * from "./ColorSelection.vue?vue&type=script&lang=ts&"
import style0 from "./ColorSelection.vue?vue&type=style&index=0&id=2d596ec6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d596ec6",
  null
  
)

export default component.exports